<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="" >
      <!--      <div class="row1" v-for="(row,i) in list"  v-if="i<1">-->
      <!--        <img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />-->
      <!--      </div>-->
      <!--      <div class="row3">-->
      <!--        <img  v-rblink="{name:'NewsList',query:{cate_id:row.id}}" v-for="(row,i) in list"  v-if="i>=1&&i<6" :src="row.pic_url" />-->
      <!--      </div>-->
      <!--      <div class="row1" style="margin: 0px 30px;" v-for="(row,i) in list"  v-if="i==6">-->
      <!--        <img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />-->
      <!--      </div>-->

      <div class="row-box">
        <div class="row-left">
          <div :class="active == label.index ? 'left-li left-li-active' : 'left-li'"
               v-for="label in columnList" :key="label.index" @click="onSelectLeft(label)">{{ label.name }}</div>
        </div>
        <div class="row-right">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="right-li flex-start" v-for="(row,i) in list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}">
            <div class="right-li-img">
<!--              <img src="../../../assets/images/other/bg-shangwuzhaoshang.png" alt="">-->
              <img :src="row.pic_url" alt="">
<!--              <div>加我企业微信</div>-->
            </div>
<!--            <div class="right-li-line"></div>-->
            <div class="right-li-user">
              <div class="right-user-one">
                <div class="right-user-label">姓名</div>
                <div class="right-user-value">{{ row.title }}</div>
              </div>
              <div class="right-user-one">
                <div class="right-user-label">单位</div>
                <div class="right-user-value">{{ row.desc }}</div>
              </div>
<!--              <div class="right-user-one">-->
<!--                <div class="right-user-label">职务</div>-->
<!--                <div class="right-user-value">河北省负责人</div>-->
<!--              </div>-->
            </div>

<!--            <div class="right-li-sign right-li-sign-province">河北省</div>-->
          </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.row-box {
  display: flex;
  justify-content: flex-start;
}
.right-user-one {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /*margin-top: .22rem;*/
}

.right-user-label {
  margin-right: .2rem;
  min-width: 24px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.right-li-user {
  margin-left: .2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 46px;
}

.right-user-value {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
}

.row-left {
  height: 100vh;
  width: 105px;
  min-width: 105px;
  background: #F5F5F5;
  text-align: center;
  overflow-y: scroll;
}

.left-li-active {
  background: #FFFFFF;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F7B500;
}

.row-right {
  height: 100vh;
  width: 100%;
  background: #fff;
  overflow-y: scroll;
}

.right-li-img img {
  width: 46px;
  height: 46px;
  border-radius: 100%;
  /*box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);*/
}

.left-li {
  height: 50px;
  line-height: 50px;
}

.right-li {
  margin: .2rem .2rem 0;
  box-shadow: 0px 1px 5px 1px rgba(0,0,0,0.05);
  padding: .3rem .2rem;
  position: relative;
  background: #fff;
  border-radius: 4px;
}

.right-li-sign-province {
  background: linear-gradient(133deg, #FA6400 0%, #FD9D00 100%);
}

.right-li-sign-city {
  background: linear-gradient(130deg, #7798FF 0%, #D4E1FF 100%);
}

.right-li-sign {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 8px 4px 8px 0px;
  color: #fff;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  padding: 2px 10px;
}

.right-li-img {
  text-align: center;
  padding: 5px;
}

.right-li-img div {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.right-li-line {
  width: 1px;
  height: 62px;
  background: #E5E5E5;
  margin: 0 .3rem 0 .2rem;
}

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
.row1{
  /*padding: 10px;*/
  margin: 0 10px;
}
.row1 img{
  width: 100%;
  margin: 10px 0 0 0 ;
}
.row3{
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  margin: 10px 10px;
  /*flex-wrap: wrap;*/
}
.row3 img{
  float: left;
  width: calc(33.33% - 10px);
  margin: 0 10px 10px 0;
}

</style>

<script>
import Vue from "vue";
import { Tab, Tabs, List, PullRefresh, Toast } from "vant";
Vue.use(Tab)
    .use(Tabs)
    .use(PullRefresh)
    .use(List)
    .use(Toast);

export default {
  name: "Hangyejinying",
  components: {
  },

  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 1,
      activeTab: [
      ],
      columnList: [
        {name: '爱心大使', index: 1, cate_id: 8},
        // {name: '顾问', index: 2, cate_id: 3},
        {name: '推广专员', index: 3, cate_id: 4},
        // {name: '十佳系列', index: 4, cate_id: 121},
      ],
      list:[],
      params:{
        cate_id:8,
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  filters: {
  },
  mounted() {
    document.title = "行业精英";
    this.fetch();
  },
  destroyed() {},
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
          "/api/cms/cmslist",
          that.params,
          res => {
            that.loading = false;
            console.log('fetchok')
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }

            if (res.data.list.length == 0) {
              that.finished = true;
            }
            that.params.pageNo += 1;
          },
          res => {
            Toast(res.msg);
          }
      );
    },

    onSelectLeft(label) {
      this.params.pageNo = 1;
      this.list = []
      this.loading = true;
      this.finished = false;
      this.active = label.index
      this.params.cate_id = label.cate_id
      this.fetch();
    },

    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// Hangyejinying.vue?c9acf258